import { CrudService } from './CrudService';
import { QuestionnaireQueryParams } from '../params/QuestionnaireQueryParams';
import { QuestionnaireDto } from '../models/questionnaire/QuestionnaireDto';
import { Args } from './BaseService';
import { AxiosPromise } from 'axios';
import { resources } from '../resources';
import { CurrentQuestionnaireVersion } from '../models/questionnaire/CurrentQuestionnaireVersion';

export class QuestionnaireService extends CrudService<QuestionnaireDto, QuestionnaireQueryParams> {
  constructor() {
    super({
      query: resources.queryQuestionnaires,
      get: resources.getQuestionnaireById,
      create: resources.createQuestionnaire,
      update: resources.updateQuestionnaire,
      idKey: 'questionnaireId',
    });
  }

  public getCurrentQuestionnaireVersion(
    questionnaireId: string,
    lang: string,
    throwErrorIfEmpty?: boolean,
    date?: string,
    args?: Args,
  ): AxiosPromise<CurrentQuestionnaireVersion> {
    return this.get<CurrentQuestionnaireVersion>(resources.getCurrentQuestionnaireVersion, {
      questionnaireId: questionnaireId,
      lang: lang,
      throwErrorIfEmpty: throwErrorIfEmpty,
      date: date,
      ...args,
    });
  }
}
